export default __webpack_public_path__ + "f8c170e772d78e38bdb213af1b463da1.svg";